<template>
  <div
    :class="`${stretch ? 'owal-tab-bar__container_stretch' : 'owal-tab-bar__container'}`"
  >
    <owal-tab
      v-for="(title, index) in this.titles"
      :key="title"
      :title="title"
      :active="activeIndices.includes(index)"
      :index="index"
      scope="title"
      @click="click(index)"
    >
      <div
        slot="content"
        slot-scope="tab"
        class="owal-tab__content"
      >
        <slot
          name="content"
          v-bind="tab"
        >
          <div>
            {{ title }}
          </div>
        </slot>
      </div>
    </owal-tab>
  </div>
</template>

<script>
import OwalTab from './OwalTab'

export default {
  name: 'OwalTabBar',
  components: {
    OwalTab,
  },
  props: {
    titles: {
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    initialActiveIndex: {
      type: Number,
      default: 0,
    },
    stretch: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      activeIndices: [this.initialActiveIndex],
    }
  },
  methods: {
    click (index) {
      if (this.multiple) {
        // toggle(index, this.activeIndices)
        if (this.activeIndices.includes(index)) {
          this.activeIndices.splice(this.activeIndices.indexOf(index))
        } else {
          this.activeIndices.push(index)
        }
      } else {
        this.activeIndices = [index]
      }

      this.$emit('change', this.activeIndices)
    },
  },
}
</script>

<style scoped>
.owal-tab-bar__container,
.owal-tab-bar__container_stretch {
  display: flex;
  flex-direction: row;
  align-content: center;
  font-family: 'Roboto', 'Lato', 'Avenir', 'Helvetica', sans;
  cursor: pointer;
}

.owal-tab-bar__container {
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 1;
  width: fit-content;
}

.owal-tab-bar__container_stretch {
  justify-content: space-around;
  flex-grow: 1;
}
</style>
